document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    const tabsList = page.querySelector('.myaccount__tabs-list');
    const content  = page.querySelector('#myaccount-tab-content');
    if (!tabsList || !content) return;

    function renderComingSoon(tabKey, label) {
        return `
            <div class="myaccount__placeholder">
                <i class="ri-tools-line"></i>
                <h3 class="myaccount__placeholder-title">${label}</h3>
                <p class="myaccount__placeholder-text">This section is coming soon.</p>
            </div>
        `;
    }

    function setActiveTab(tabKey) {
        const items = tabsList.querySelectorAll('.myaccount__tabs-item');
        let activeLabel = tabKey;
        let isBuilt = false;

        items.forEach(item => {
            const link = item.querySelector('.myaccount__tabs-link');
            if (!link) return;
            const key   = link.dataset.tab;
            const built = link.dataset.built === 'true';
            const isOn  = key === tabKey;

            item.classList.toggle('is-active', isOn);
            link.setAttribute('aria-selected', isOn ? 'true' : 'false');

            if (isOn) {
                isBuilt = built;
                const labelSpan = link.querySelector('span');
                if (labelSpan) activeLabel = labelSpan.textContent.trim();
            }
        });

        page.dataset.activeTab = tabKey;

        // Toggle visibility of pre-rendered tab pages.
        const tabPages = content.querySelectorAll('[data-tab-page]');
        let matched = false;
        tabPages.forEach(p => {
            const isOn = p.dataset.tabPage === tabKey;
            p.hidden = !isOn;
            if (isOn) matched = true;
        });

        // Remove any previous coming-soon placeholder.
        const oldPh = content.querySelector('[data-tab-placeholder]');
        if (oldPh) oldPh.remove();

        if (!matched) {
            // Tab wasn't pre-rendered (built=false) — show coming-soon stub.
            const wrap = document.createElement('div');
            wrap.dataset.tabPlaceholder = 'true';
            wrap.innerHTML = renderComingSoon(tabKey, activeLabel);
            content.appendChild(wrap);
        }
    }

    tabsList.addEventListener('click', (e) => {
        const link = e.target.closest('.myaccount__tabs-link');
        if (!link) return;
        e.preventDefault();
        const tabKey = link.dataset.tab;
        if (!tabKey) return;
        if (page.dataset.activeTab === tabKey) return;
        setActiveTab(tabKey);
        history.replaceState(null, '', '/myaccount');
    });
});
